

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';  


// Importing custom components and styles
import scrollTop from '../components/scrollTop';
import './Skill.css';
import APIEndPoints from '../middleware/APIEndPoints';


const Projects = () => {

    const [projectsData, setProjectsData] = useState([]); 
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null); 

const getProject = APIEndPoints.myprojects.url;

    useEffect(() => {
        scrollTop();
        fetchProjects();  

    }, []);


    const navigate = useNavigate();

    // Function to fetch project data from the backend
    const fetchProjects = async () => {
        try {
            const response = await axios.get(getProject);  
            setProjectsData(response.data); 
            setLoading(false); 
        } catch (error) {
            console.error('Error fetching projects:', error);
            setError('Failed to load projects');
            setLoading(false); 
        }
    };





    const handleViewDetails = (project) => {
        navigate(`/project-details/${project.id}`, { state: { project } });
    };

    return (
        <div className='mt-4 pt-4 '>
            {/* Header Section */}
            <motion.div
                initial={{ opacity: 0, y: -80 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1.2, ease: [0.25, 0.25, 0.25, 0.75] }}
                className='text-center '
            >
                <h4 className='text-3xl lg:text-[3rem] uppercase text-accent font-medium  tracking-wide'>
                    My Projects
                </h4>
                <h2 className='text-4xl lg:text-[4rem] font-bold  leading-tight'>
                    My Handcrafted Projects Across Diverse Fields
                </h2>
                <p className='text-lg text-gray-400'>
                    Explore a wide range of innovative projects, from front-end designs to back-end systems, and everything in between. Each project reflects a blend of creativity, technical expertise, and a passion for delivering impactful solutions.
                </p>
            </motion.div>



            {/* Projects Container using map function */}
            <div className="skillcontainer mx-auto px-2 pl-2 sm:pl-[14rem] md:pl-4 ">

                <motion.div
                    initial={{ opacity: 0, y: 80 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1.2, delay: 0.1, ease: [0.25, 0.25, 0.25, 0.75] }}
                    className="flex flex-wrap justify-around ">
                    {projectsData.map((project, index) => (
                        <motion.div
                            key={project.id}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: index * 0.1, ease: [0.25, 0.25, 0.25, 0.75] }}
                            className="relative w-full md:w-1/2 lg:w-1/3 mb-8">

                            <div className='card relative'>
                                <div className='face face1 border-purple-900 border-2 rounded'>

                                    <motion.div
                                        className="content flex justify-center items-center space-x-5 font-bold text-2xl p-2 bg-white/40"
                                    >
                                        <img
                                            src={project.imageSlider?.[0]?.url}
                                            alt={project.title}
                                            className='w-40 h-40 p-1 border-white border-2 rounded'
                                        />
                                        <h3 className='uppercase text-purple-800'>{project.title}</h3>
                                    </motion.div>



                                </div>
                                <div className="face face2 relative">
                                    <div className="content w-full h-full space-y-4 text-black flex flex-col justify-end">
                                        <div>
                                            {project.description}
                                            
                                        </div>
                                        <div className='flex justify-center'>

                                            <button
                                                onClick={() => handleViewDetails(project)}
                                                className='relative  font-semibold  border-white border-2  py-0 px-2 sm:py-1 sm:px-6 text-white  bg-[#1d0c39] hover:opacity-80 hover:bg-cyan-400 hover:text-black'>
                                                View Details
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </div>


                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </div>
    );
}

export default Projects;


